import script from "./date-range-widget.vue?vue&type=script&setup=true&lang=js"
export * from "./date-range-widget.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__